import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {validateFields, validateField} from './../../../utilities/validation/validator';
import lodash from 'lodash';

const paymentMethods = {
  CREDIT_CARD: 'כרטיס אשראי',
  BANK: 'הוראת קבע בחשבון',
  DIFFERENT: 'חשבונות ללא אמצעי תשלום',
  PAYPAL: 'PayPal',
};
const brandNameHe = () => window.Config?.brand_Name_HE;

const selectProviderRadioBtns = [
  {id: 'cellcom', get label() {
    return `${brandNameHe()}`;
  }, value: 'Cellcom'},
  {id: 'Netvision', label: "נטוויז'ן", value: 'Netvision'},
];
const paymentMethodsRadioBtns = [
  {id: 'credit-card', label: paymentMethods.CREDIT_CARD, value: 'CC'},
  {id: 'bank', label: paymentMethods.BANK, value: 'Bank'},
];

export const getContactCompanyList = createAsyncThunk('updatePayment/getContactCompanyList', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getContactCompanyList', []);
    return {error: false, data: result.Body};
  } catch (error) {
    return {error: true};
  }
});

export const getOrgPaymentMethodList = createAsyncThunk('updatePayment/getOrgPaymentMethodList', async (data) => {
  try {
    const result = await ProviderManager.getProviderData('getOrgPaymentMethodList', [
      data.idNumber,
      data.selectedProvider,
      data.isPrivateUserFlow,
    ]);

    return {
      error: false,
      data: result.Body.paymentMethodAccounts,
      idNumber: !data.isPrivateUserFlow ? data.idNumber : result.Body.idNumber,
      selectedProvider: data.selectedProvider,
      onlyPSIDAccounts: result.Body.onlyPSIDAccounts,
      accountHasDebt: result.Body.accountHasDebt,
      customerAdditionalIdList: result.Body.customerAdditionalIdList,
    };
  } catch (error) {
    return {error: true};
  }
});

export const updatePaymentMethod = createAsyncThunk('updatePayment/updatePaymentMethod', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('updatePaymentMethod', [
      data.AccountList,
      data.BanOrPsid,
      data.CCToken,
      data.CardYear,
      data.CardMonth,
      data.CardCvv,
      data.CreditCardType,
      data.CCFourLastNumbers,
      data.PaymentOwnerFirstName,
      data.PaymentOwnerLastName,
      data.ConsumerId,
      data.EMail,
      data.IdNumber,
      data.OrgType,
      data.PaymentMethodType,
      data.PaymentType,
      data.PhoneNumber,
      data.BankAccountFileGuid,
      data.AuthNo,
      data.IsBusiness,
      data.PrivateUserIdNumber,
      data.PaymentEntityId,
      data.PaymentEntityFirstName,
      data.PaymentEntityLastName,
      data.PaymentEntityCity,
      data.PaymentEntityStreet,
      data.PaymentEntityZip
    ]);
    if (data.IsBusiness) {
      return result.Header.ReturnCode == 0 ? { error: false } : { error: true };
    }
    if ((!data.IsBusiness && result.Body.statusCode != 0) || (!data.IsBusiness && result.Header.ReturnCode != 0)) {
      thunkAPI.dispatch(setPrivateUserUpdateObj(result.Body));
    }
    var isSuccess = result.Header.ReturnCode == 0 && result.Body.statusCode == 0;
    if (isSuccess) {
      var paymentCgState = thunkAPI.getState().PaymentCG;
      thunkAPI.dispatch(setSelectedForUpdate({ CCToken: paymentCgState.CCToken }));
    }
    return isSuccess ? result : { error: true };
  } catch (error) {
    return {error: true};
  }
});
export const creditCardValidation = createAsyncThunk('updatePayment/creditCardValidation', async (payment) => {
  try {
    const result = await ProviderManager.getProviderData('creditCardValidation', [payment.cCType, payment.cCToken, payment.id]);
    const isSuccess = result.Body.isSuccess;
    return isSuccess;
  } catch (error) {
    return false;
  }
});

export const onlyMobileML = createAsyncThunk('updatePayment/SendPhoneForMl', async ({ phoneNumber, banNumberList }) => {
  try {
    const result = await ProviderManager.getProviderData('onlyMobileML', {
      phoneNumber,
      banNumberList
    });
    return result;
  } catch (error) {
    throw error;
  }
});


const initialState = {
  isLoading: false,
  blockId: '',
  isBusinessBlock: false,
  isDeptPayment: false,
  ifMultiple: false,
  ifForbidden: false,
  progressBarPoints: [20, 40, 60, 80, 100],
  progressBarPercent: 0,
  animationTimeOut: 400,
  submitAnimation: true,
  error: false,
  currentStep: 1,
  paymentMethods: paymentMethods,
  selectProviderRadioBtns: selectProviderRadioBtns,
  paymentMethodsRadioBtns: paymentMethodsRadioBtns,
  contactId: '',
  contactFirstName: '',
  contactLastName: '',
  contactPhoneNumber: '',
  orgDetailList: [],
  selectedForUpdate: null,
  selectedProvider: 'Cellcom',
  selectedCompanyId: null,
  selectedPaymentMethods: 0,
  selectedInvoices: 0,
  newSelectedPaymentMethod: 'CC',
  customerEmail: '',
  completed: false,
  renderFromDeptPayment: false,
  isCreditGuardCloudMode: true,
  customerAdditionalIdList: [],
  customerId: '',

  form: {
    email: '',
    valid: '',
    errors: {
      email: '',
    },
    rules: {},
  },
  userBanPsids: null,
  isPrivateDefaultAreSelected: false,
  privateUserUpdateResultObj: null,
  onlyPSIDAccounts: false,
  accountHasDebt: false,
};

const updatePaymentMethodSlice = createSlice({
  name: 'updatePayment',
  initialState: initialState,
  reducers: {
    resetState: (state) => initialState,
    handleCurrentStep: (state, action) => {
      return {...state, currentStep: action.payload, submitAnimation: false};
    },
    setBusinessBlockFlag: (state, action) => {
      state.isBusinessBlock = action.payload.isBusiness;
      state.blockId = action.payload.blockId || '';
    },
    setPrivateUserUpdateObj: (state, action) => {
      return {...state, privateUserUpdateResultObj: action.payload};
    },
    setProgressBarPercent: (state, action) => {
      return {...state, progressBarPercent: action.payload};
    },
    setIsPrivateDefaultAreSelected: (state, action) => {
      state.isPrivateDefaultAreSelected = true;
    },
    saveSelectedCustomers: (state, action) => {
      if (!action.payload) {
        return {...state};
      }
      const {dataWithSelectedCustomers, selectedPayments, selectedInvoices} = action.payload;

      return {
        ...state,
        submitAnimation: true,
        selectedPaymentMethods: selectedPayments,
        selectedInvoices: selectedInvoices,
        selectedForUpdate: {...state.selectedForUpdate, customersPaymentData: dataWithSelectedCustomers},
      };
    },
    saveNewSelectedPaymentMethod: (state, action) => {
      return {...state, newSelectedPaymentMethod: action.payload, submitAnimation: true};
    },
    deptPaymentDataToUpdate: (state, action) => {
      return {
        ...state,
        currentStep: 4,
        isDeptPayment: true,
        renderFromDeptPayment: true,
        contactId: action.payload.contactId,
        contactPhoneNumber: action.payload.contactPhoneNumber,
        selectedForUpdate: action.payload.selectedForUpdate,
        selectedProvider: action.payload.selectedProvider,
        isLoading: false,
        submitAnimation: true,
      };
    },
    resetDeptPaymentFlag: (state, action) => {
      return {...state, renderFromDeptPayment: false};
    },
    setMultiple: (state, action) => {
      return {...state, ifMultiple: action.payload};
    },
    setForbidden: (state, action) => {
      return {...state, ifForbidden: action.payload};
    },
    setSelectedCompanyId: (state, action) => {
      return {...state, selectedCompanyId: action.payload};
    },
    setSelectedProvider: (state, action) => {
      return {...state, selectedProvider: action.payload};
    },
    setCompletedFlag: (state, action) => {
      state.completed = action.payload;
    },
    setSelectedForUpdate: (state, action) => {
      var ccToken = action.payload.CCToken;
      state.selectedForUpdate.customersPaymentData.forEach(paymentData => {
        if (paymentData.customersList[0].checked) {
          paymentData.paymentMethodNumber = ccToken.slice(-6);
          return paymentData;
        }
      });
      return state;
    },
    validateHandler: {
      reducer(state, action) {
        state['form'] = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    clearIsValid: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = lodash.cloneDeep(payload);
        form.valid = '';
        return {payload: form};
      },
    },
    changeHandler: {
      reducer(state, action) {
        state['form'] = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
    saveToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
  },
  extraReducers: {
    [getContactCompanyList.pending]: (state) => {
      return {...state, isLoading: true};
    },
    [getContactCompanyList.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        const {contactId, contactFirstName, contactLastName, contactPhoneNumber, bussinessOrgList} = action.payload.data;
        return {
          ...state,
          contactId: contactId,
          contactFirstName: contactFirstName,
          contactLastName: contactLastName,
          contactPhoneNumber: contactPhoneNumber,
          orgDetailList: bussinessOrgList || [],
          isLoading: false,
        };
      } else {
        return {...state, error: true, currentStep: 6, isLoading: false};
      }
    },
    [getContactCompanyList.rejected]: (state, action) => {
      return {...state, error: true, currentStep: 6, isLoading: false};
    },
    [getOrgPaymentMethodList.pending]: (state) => {
      return {...state, isLoading: true, submitAnimation: false};
    },
    [getOrgPaymentMethodList.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        const selectedForUpdate = state.orgDetailList.find((org) => org.idNumber == action.payload.idNumber);
        const newData = {...selectedForUpdate, customersPaymentData: action.payload.data};
        state.selectedForUpdate = newData;
        state.isLoading = false;
        state.selectedProvider = action.payload.selectedProvider;
        state.submitAnimation = true;
        state.onlyPSIDAccounts = action.payload.onlyPSIDAccounts;
        state.accountHasDebt = action.payload.accountHasDebt;
        state.customerAdditionalIdList = action.payload.customerAdditionalIdList;
        state.customerId = action.payload.idNumber;

        return state;
      } else {
        state.error = true;
        state.currentStep = 6;
        state.isLoading = false;
        return state;
      }
    },
    [updatePaymentMethod.pending]: (state) => {
      state.completed = false;
      state.isLoading = true;
      state.submitAnimation = false;
      return state;
    },
    [updatePaymentMethod.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        state.privateUserUpdateResultObj = action.payload.Body;
        if (action.payload.statusCode == '99' && action.payload.statusDescription == 'Invalid params') {
          state.error = true;
        } else {
          state.error = false;
        }
      } else {
        state.error = true;
      }
      state.submitAnimation = true;
      state.completed = true;
      state.isLoading = false;
      return state;
    },
    [updatePaymentMethod.rejected]: (state, action) => {
      state.error = true;
      state.submitAnimation = true;
      state.completed = true;
      state.isLoading = false;
    },
    [creditCardValidation.fulfilled]: (state, action) => {
      return state;
    },
  },
});

export const {
  resetState,
  handleCurrentStep,
  setProgressBarPercent,
  saveSelectedCustomers,
  saveNewSelectedPaymentMethod,
  validateHandler,
  changeHandler,
  setPayment,
  resetDeptPaymentFlag,
  deptPaymentDataToUpdate,
  setMultiple,
  setForbidden,
  setSelectedCompanyId,
  setSelectedProvider,
  setPrivateUserUpdateObj,
  saveToHistory,
  clearHistory,
  setIsPrivateDefaultAreSelected,
  setBusinessBlockFlag,
  setCompletedFlag,
  setSelectedForUpdate,
} = updatePaymentMethodSlice.actions;

export default updatePaymentMethodSlice.reducer;
